import Button from "../Button/Button"

export default function TileWizardActions({
  backButtonHandler,
  onSaveHandler,
}) {
  return (
    <div className="flex items-center justify-end border-t px-8 py-4">
      {!!backButtonHandler && (
        <Button
          className="mr-auto"
          variant="secondary_default"
          onClick={backButtonHandler}
        >
          Back
        </Button>
      )}

      <Button className="ml-auto" onClick={onSaveHandler}>
        Save
      </Button>
    </div>
  )
}
